export const strapiBaseUrl = process.env.NEXT_PUBLIC_STRAPI_URL;
export const cmsUrl = process.env.NEXT_PUBLIC_CMS_URL;
